module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "image2"
  }, [_c('img', {
    attrs: {
      "alt": "chapter",
      "src": "images/chapter.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-paraa"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/frontmatter01#frontmatter01"
    }
  }, [_c('strong', [_vm._v("Introduction:")]), _vm._v(" Political Lies: A Self-Defense Manual")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter01#chapter01"
    }
  }, [_c('strong', [_vm._v("The First Lie:")]), _vm._v(" The Abortion Debate Matters")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter02#chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("The Second Lie:")]), _vm._v(" Gun Control Reduces Crime")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter03#chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("The Third Lie:")]), _vm._v(" Religion and Politics Don’t Mix")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter04#chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("The Fourth Lie:")]), _vm._v(" Immigration Hurts America")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter05#chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("The Fifth Lie:")]), _vm._v(" All Politicians Are Corrupt")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter06#chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("The Sixth Lie:")]), _vm._v(" Money Buys Elections")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter07#chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("The Seventh Lie:")]), _vm._v(" Fat Cats Are the Problem")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter08#chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("The Eighth Lie:")]), _vm._v(" The Budget Will Be Balanced by the Year 2002")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter09#chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("The Ninth Lie:")]), _vm._v(" Social Security Is a Sacred Government Trust")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter10#chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("The Tenth Lie:")]), _vm._v(" Medicare Works")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter11#chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("The Eleventh Lie:")]), _vm._v(" Tax Cuts Are Good")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter12#chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("The Twelfth Lie:")]), _vm._v(" Education—More Money Equals Better Results")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter13#chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("The Thirteenth Lie:")]), _vm._v(" The Environment—It's Mother Earth or Mother Lode")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter14#chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("The Fourteenth Lie:")]), _vm._v(" Republicans Believe in Smaller Government")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter15#chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("The Fifteenth Lie:")]), _vm._v(" Democrats Are Compassionate")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 72
// module chunks = 0